import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import LoginPage from "../pages/LoginPage";
import HomePage from "../pages/HomePage";
import Paths from "./Paths";
import { useSelector } from "react-redux";

const AppRouter = () => {
  const { user } = useSelector((state) => state.user);

  return (
    <BrowserRouter>
      {!user ? (
        <Routes>
          <Route path="*" element={<LoginPage />} />
        </Routes>
      ) : (
        <Routes>
          <Route path={Paths.home} element={<HomePage />} />
        </Routes>
      )}
    </BrowserRouter>
  );
};

export default AppRouter;
